import {Component, Object3D, property, Type} from '@wonderlandengine/api';

import {LevelData, LevelDescription} from './data/level-data.js';
//import { ObjectCache } from "./utils/objectCache";
import {storageSpace13} from './globals.js';
import {WLUtils} from './utils/WLUtils.js';
import {BoxController} from './box-controller.js';

export class LevelGenerator extends Component {
    static TypeName = 'level-generator';

    @property.object({required: true})
    levelRoot!: Object3D;

    currentLd: LevelDescription;
    levelParent: Object3D;

    /**
     * Generates a level
     * @param {Number} level The level to generate
     * @returns {cameraPosition, targetsToComplete, cameraRotation}
     */
    generate(level: number | 'Title' = 0, parent = null) {
        this.currentLd = LevelData[level];

        if (this.levelParent) {
            this.levelParent.destroy();
            this.levelParent = null;
        }
        this.levelParent = this.engine.scene.addObject(this.levelRoot);
        this.levelParent.name = `levelParent(${level})`;

        //this.levelParent.children.length = 0;
        // if (!StorageSpace13.globalObjectCache) {
        //     StorageSpace13.globalObjectCache = new ObjectCache(this.engine, 'blocks', 1200, this.levelParent, 8000);
        // } else {
        //     StorageSpace13.globalObjectCache.reset();
        // }
        // this.blockCache = StorageSpace13.globalObjectCache;

        let cameraPosition, cameraRotation;
        let targetsToComplete = 0;
        for (let layer = 0; layer < this.currentLd.layer.length; layer++) {
            for (let row = 0; row < this.currentLd.layer[layer].data.length; row++) {
                for (let col = 0; col < this.currentLd.layer[layer].data[row].length; col++) {
                    let tile = this.currentLd.layer[layer].data[row][col];

                    if (layer == 0 && tile != 'T') {
                        this.createFloor(row - this.currentLd.width / 2, 0, col - this.currentLd.height / 2);
                    }

                    if (layer == this.currentLd.layer.length - 1) {
                        this.createCeiling(row - this.currentLd.width / 2, layer + 1, col - this.currentLd.height / 2);
                    }

                    if (tile == 0) {
                        continue;
                    }
                    switch (tile) {
                        case 'S':
                            cameraPosition = [row - this.currentLd.width / 2, 0, col - this.currentLd.height / 2];
                            break;
                        case 'B':
                            this.createBox(row - this.currentLd.width / 2, col - this.currentLd.height / 2, layer);
                            break;
                        case 'T':
                            this.createTarget(row - this.currentLd.width / 2, col - this.currentLd.height / 2, layer);
                            targetsToComplete++;
                            break;

                        default:
                            this.createCube(
                                row - this.currentLd.width / 2,
                                layer,
                                col - this.currentLd.height / 2,
                                tile
                            );
                            break;
                    }
                }
            }
        }
        // console.log(`blocks in cache: ${this.blockCache.index}`);
        cameraRotation = this.currentLd.cam;
        return {cameraPosition, targetsToComplete, cameraRotation};
    }

    createCube(x, y, z, tile) {
        let t = '0000' + tile;
        let blockObj = this.object.children.find((x) => x.name === `Block${t.substr(t.length - 2, 2)}`);
        let obj = WLUtils.clone(blockObj, this.levelParent);
        obj.resetPositionRotation();
        obj.setPositionLocal([x, y, z]);
    }

    createCeiling(x, y, z) {
        this.createTile(x, y, z, `Ceiling01`);
    }

    createFloor(x, y, z) {
        this.createTile(x, y, z, `Floor01`);
    }

    createTarget(x, z, layer) {
        this.createTile(x, layer, z, `Floor_Target`);
    }

    createBox(x, z, layer) {
        let blockObj = this.object.children.find((x) => x.name === 'Block06');
        let box = WLUtils.clone(blockObj, this.levelParent);
        box.resetPositionRotation();
        box.setPositionLocal([x, layer, z]);
        let boxController = box.getComponent(BoxController);
        boxController.setState(storageSpace13.levelState.getNewBoxState());
    }

    createTile(x, y, z, tile) {
        let blockObj = this.object.children.find((x) => x.name === tile);
        let obj = WLUtils.clone(blockObj, this.levelParent);
        obj.resetPositionRotation();
        obj.setPositionLocal([x, y, z]);
    }
}
